<div class="tabs-container">
  <div class="tabs-scroll-container" #tabsScrollContainer>
    <div class="tabs-header">
      <div
        *ngFor="let tab of tabs; trackBy: trackByTabId"
        class="tab-item"
        [class.active]="isActive(tab.id)"
        [class.disabled]="isDisabled(tab)"
        (click)="!isDisabled(tab) && onTabClick(tab.id)"
        [attr.aria-selected]="isActive(tab.id)"
        [attr.aria-disabled]="isDisabled(tab)"
        role="tab"
      >
        <span class="tab-label">{{ tab.label }}</span>

        <div class="tab-indicator" *ngIf="isActive(tab.id)"></div>
      </div>
    </div>
  </div>

  <div class="tabs-base-line"></div>
</div>
